import request from '@/utils/request';
export const importDept = (data: any) =>
  request({
    url: 'Department/importDepartment',
    method: 'POST',
    data
  });


export const modifyDepartmentParent = (data: any) =>
  request({
    url: 'Department/modifyDepartmentParent',
    method: 'PUT',
    data
  });

// 导出部门
export const exportDepartment = (params: any) =>
  request({
    url: 'Department/exportDepartment',
    method: 'get',
    params
  });

// 修改部门类型
export const modifyDepartmentType = (data: any) =>
  request({
    url: 'Department/modifyDepartmentType',
    method: 'PUT',
    data
  });

